import config from '../../config';

const LOG_LEVELS = ['trace', 'debug', 'info', 'warn', 'error']
const logLevel = LOG_LEVELS.indexOf(config.logLevel) ?? LOG_LEVELS.indexOf(config.logLevel ?? 'error')

function _log(level: string, ...msg: any) {
    if (logLevel > LOG_LEVELS.indexOf(level)) return
    switch (level) {
        case 'error':
            console.error(...msg);
            break;
        case 'warn':
            console.warn(...msg);
            break;
        case 'info':
            console.info(...msg);
            break;
        default:
            console.log(...msg);
            break;
    }

}

_log('info', `Logger initialized with "${LOG_LEVELS[logLevel]}" level`)

interface Logger {
    trace(...msg:any): void
    debug(...msg:any): void
    info(...msg:any): void
    warn(...msg:any): void
    error(...msg:any): void
}

export const log: Logger = {
    /**
     * Log that trace what part of the code is being executed
    */
    trace: (...msg: any) => _log('trace', ...msg),
    /**
     * Log that provide informations only usefull to developpers for debugging purpose
     */
    debug: (...msg: any) => _log('debug', ...msg),
    /**
     * Log that provide generally usefull informations :
     * - Services created / destroyed
     * - Configuration assumptions
     * ...
     */
    info: (...msg: any) => _log('info', ...msg),
    /**
     * Log things that went wrong without crashing the application
     */
    warn: (...msg: any) => _log('warn', ...msg),
    /**
     * Log things that make the application unable to run correctly
     */
    error: (...msg: any) => _log('error', ...msg)
}
